import React, {useRef, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Form} from '@unform/web';
import * as Yup from 'yup';
import {
	Row,
	Col,
	FormGroup,
	Button,
	Label, Alert
} from 'reactstrap';
import ReactGA from 'react-ga4';
import Input from '~/components/Input';
import {LoaderLista} from '~/components/Loaders';
import * as ActionsAuth from '~/store/modules/auth/actions';
import history from '~/services/history';
import getValidationErrors from '~/utils/getValidationErrors';
import {Container, Box, Background, Logo} from '../styles';


function EnvironmentAlert() {
	if (process.env.REACT_APP_ENV !== 'PRODUCTION') {
		return (
			<Alert color="danger" className="text-center">
				<strong>
					Atenção, você está acessando o ambiente:
					{process.env.REACT_APP_ENV}
				</strong>
			</Alert>
		);
	}
	return null;
}


function LoginMaster() {
	const {user} = useSelector((state) => state.auth);
	const formRef = useRef(null);
	const dispatch = useDispatch();
	const [isPageLoaded, setPageLoaded] = useState(false);

	useEffect(() => {
		const afterPageLoad = () => {
			if (window.props) {
				dispatch(ActionsAuth.requestLogin(window.props));
			}
		};

		if (document.readyState === 'complete') {
			setPageLoaded(true);
		}

		// Ouvinte pra quando a página carregar por completo
		window.addEventListener('load', () => {
			setPageLoaded(true);
		});

		if (isPageLoaded) {
			afterPageLoad();
		}
	}, [isPageLoaded]);

	useEffect(() => {
		dispatch(ActionsAuth.cleanAllToken(''));
	}, []);
	

	function handleClickLoginPadraoGA4() {
		ReactGA.event({
			category: "login_padrao",
			action: `Login Padrão`,
			label: `Login Padrão`,
		});
	}


	const handleSubmitLogin = async (dados) => {
		const dadosTrim = {
			username: dados.username.trim(),
			password: dados.password.trim(),
			target_email: dados.target_email.trim(),
		}
		try {
			const schema = Yup.object().shape({
				username: Yup.string().required('O e-mail é obrigatório'),
				password: Yup.string().required('A senha é obrigatória'),
				target_email: Yup.string()
					.email('Formato de e-mail inválido')
					.required('O e-mail é obrigatório'),
			});

			await schema.validate(dadosTrim, {
				abortEarly: false,
			});

			dispatch(ActionsAuth.requestLoginMaster(dadosTrim));

			handleClickLoginPadraoGA4();
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errors = getValidationErrors(err);
				formRef.current.setErrors(errors);
			}
		}
	};

	function handleEsqueciSenha() {
		history.push('reset-pass');
	}

	return (
		<Container>
			<Background />
			<Col>
				<Box style={{padding: 20}}>
					<EnvironmentAlert />
					<Logo />

					<p style={{textAlign: 'center'}}>
						VOCÊ ESTÁ NO ACESSO
						<b> MASTER </b>
					</p>
					{user.loading ? (
						<LoaderLista
							message="Entrando..."
							lista={[]}
							loading={user.loading}>
							<div />
						</LoaderLista>
					) : (
						<Form ref={formRef} onSubmit={handleSubmitLogin}>

							<FormGroup>
								<Label>
									Digite seu e-mail ou usuário
								</Label>
								<Input
									name="username"
									type="text"
									placeholder="E-mail ou usuário"
								/>
							</FormGroup>
							<FormGroup>
								<Label>Digite sua senha</Label>
								<Input
									name="password"
									type="password"
									placeholder="Senha"
								/>
							</FormGroup>
							<FormGroup>
								<Label>
									Digite seu e-mail do cliente
								</Label>
								<Input
									name="target_email"
									type="text"
									placeholder="E-mail do cliente"
								/>
							</FormGroup>
							<Row className="rowButton">
								<Col>
									<Button
										outline
										color="primary"
										className="buttonComponentOutline"
										onClick={() => handleEsqueciSenha()}>
										ESQUECI A SENHA
									</Button>
								</Col>
								<Col>
									<Button
										color="primary"
										className="buttonComponent"
										type="submit"
										disabled={user.loading}>
										ENTRAR
									</Button>
								</Col>
							</Row>
						</Form>
					)}
				</Box>
			</Col>

		</Container>
	);
}

export default LoginMaster;
